import React from 'react';

import { cn, withRef } from '@udecode/cn';
import { PlateElement, useElement } from '@udecode/plate-common';
import { useLink } from '@udecode/plate-link';

export const LinkElement = withRef(
  ({ children, className, ...props }, ref) => {
    const element = useElement();
    const { props: linkProps } = useLink({ element });

    return (
      <PlateElement
        asChild
        className={cn(
          'font-medium text-primary underline decoration-primary underline-offset-4',
          className
        )}
        ref={ref}
        {...(linkProps)}
        {...props}
      >
        <a>{children}</a>
      </PlateElement>
    );
  }
);